import { FormItem } from 'modules/common/components/Form'
import { TextCalibriBold } from 'modules/common/components/Typography'
import styled from 'styled-components/macro'
import { ITheme } from 'styles/types'

export const LogoWrapper = styled.div`
  margin-bottom: 64px;

  @media (max-height: 400px) {
    margin-bottom: 20px;
  }
`

export const ButtonWrapper = styled(FormItem)`
  text-align: center;
  line-height: 0;

  @media (max-height: 450px) {
    transform: scale(0.8);
  }
`

export const Error = styled(TextCalibriBold)`
  display: block;
  text-align: center;
  margin: 30px 0;
`
export const TextWrapper = styled.div`
  margin-bottom: 5px;
`

export const Text = styled(TextCalibriBold)`
  text-align: left;
  font-size: 23px;
  line-height: 28px;
  display: block;
  white-space: pre-line;

  @media ${({ theme }: { theme: ITheme }) => theme.breakpoints.md} {
    font-size: 17px;
    line-height: 1;
  }
`

export const EmptyLine = styled(Text)`
  visibility: hidden;
`
export const ORText = styled(Text)`
  text-align: center;
  margin-bottom: 10px;
  text-transform: uppercase;
`
